import { SourceType } from '../SourceType'
import * as api from '../task-detail-api'
import { TransactionType } from '../TransactionType'
// import { SURedating } from '../../model'
import { GeneralData } from '../../GeneralService'
import { pipe } from 'fp-ts/function'
import * as O from 'fp-ts/lib/Option'
import { ReinstatementModel } from '../Reinstatement'

export interface RedatingPayload {
  rcd: string
  newRcd: string
  frequency: string
  regularPremium: number
  lapsedDate: string
  totalReinsAmount: number
  agentCode: string
  agentName: string
  lifeAssuredList: LifeAssuredData[]
}
export interface LifeAssuredData {
  clientNo: string
  clientName: string
  healthStateChange: boolean
  occupationChange: boolean
  curOccupation: string
  newOccupation: string
  activityChange: boolean
  newActivity: string
  companyChange: boolean
  newCompany: string
}

export interface VERIRedating {
  tag: TransactionType.REDATING
  clientName: string
  submissionData: RedatingPayload
}

export const Redating = (
  detail: api.Redating,
  poName: string,
  occupationList: GeneralData[],
  reinData: ReinstatementModel.ReinData
): VERIRedating => {
  let payloadData = detail.payload.body
  const LAList = payloadData.lifeAssuredList.map((LAItem) => {
    let currentOccupation = '',
      newOccupation = ''
    if (LAItem.occupationChange) {
      currentOccupation = pipe(
        occupationList.find((x) => x.code === LAItem.curOccupation),
        O.fromNullable,
        O.map((item) => item && item.name),
        O.getOrElse(() => '')
      )
      newOccupation = pipe(
        occupationList.find((x) => x.code === LAItem.newOccupation),
        O.fromNullable,
        O.map((item) => item && item.name),
        O.getOrElse(() => '')
      )
    }
    const clientName = pipe(
      reinData.lifeAssured.find((x) => x.clientId === LAItem.clientNo),
      O.fromNullable,
      O.map((item) => item && item.name),
      O.getOrElse(() => '')
    )
    return {
      ...LAItem,
      clientName: clientName,
      curOccupation: currentOccupation,
      newOccupation: newOccupation
    }
  })
  const submissionData: RedatingPayload = {
    ...payloadData,
    lifeAssuredList: LAList
  }
  switch (detail.source) {
    case SourceType.PULSE:
    case SourceType.PULSE4OPS: {
      return {
        tag: TransactionType.REDATING,
        clientName: poName,
        submissionData: submissionData
      }
    }
  }
}
